<div class="min-h-screen flex flex-col">

  <main class="flex-1">
    <router-outlet></router-outlet>
  </main>

  <app-footer></app-footer>
</div>